import {
  ClientConfig,
  createClient,
  createMicrophoneAndCameraTracks,
} from "agora-rtc-react";

export const appId = "487313108aca464bb93de894daedc887";
export const token =
  "007eJxTYOhT61137v/BS1u33OZbPsVjTbfOi/aYtpX2Wd/MRAy2Xv2uwGBiYW5saGxoYJGYnGhiZpKUZGmckmphaZKSmJqSbGFhvk9gVXJDICPDtqVWzIwMEAjiszIElhalVjAwAAA/vCJd";

export const config: ClientConfig = { mode: "rtc", codec: "vp8" };
export const useClient = createClient(config);
export const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();
export const Channel = "Qurex";
